import { t } from "i18next";
import { inject } from "vue";
import { useConfirm, useSnackbar } from "vuetify-use-dialog";
import {
  ConfirmDialogKeyValue,
  ConfirmDialogOptions
} from "vuetify-use-dialog/utils";
import { useTheme } from "vuetify/lib/framework.mjs";

export function useConfirmComposable() {
  const dialog = inject("ConfirmDialogKey") as ConfirmDialogKeyValue;
  const theme = useTheme();

  function confirm(
    message: string,
    snackbarSuccess: boolean = true,
    snackbarFailure: boolean = false
  ) {
    // const createSnackbar = useSnackbar();
    const options = {
      dialogProps: { width: 400 },
      cardProps: { color: "warning" },
      title: t("actions.confirmation." + message + ".title"),
      content: t("actions.confirmation." + message + ".content"),
      confirmationText: t("actions.confirmation." + message + ".confirm"),
      cancellationText: t("actions.confirmation." + message + ".cancel"),
      cancellationButtonProps: {
        // @ts-ignore
        "data-cy": message + "-cancel-button"
      },
      confirmationButtonProps: {
        // @ts-ignore
        "data-cy": message + "-confirm-button"
      }
    };
    if (!dialog) throw new Error("Missing dialog instance");

    return new Promise((resolve, reject) =>
      dialog
        .mountDialog(
          // @ts-ignore
          {
            theme: theme.name.value,

            ...options
          }
        )
        .then((confirm) => {
          if (confirm) {
            resolve(true);
            snackbarSuccess &&
              dialog.mountSnackbar({
                theme: theme.name.value,
                ...{
                  text: t("actions.confirmation." + message + ".success"),
                  showCloseButton: false,
                  snackbarProps: { color: "success", timeout: 1000 }
                }
              });
          } else {
            reject();
            snackbarFailure &&
              dialog.mountSnackbar({
                theme: theme.name.value,
                ...{
                  text: t("actions.confirmation." + message + ".failure"),
                  showCloseButton: false,
                  snackbarProps: { color: "error", timeout: 1000 }
                }
              });
          }
        })
    );
  }

  return confirm;
}
